import React from "react";
import { HeaderProps } from "./Header.types";
import { HeaderContainer } from "./Header.style";
import {
  ComponentMapping,
  Container
} from "@adobe/aem-react-editable-components";
import { CoreContainerState } from "@adobe/aem-core-components-react-spa";

export default class Header extends Container<HeaderProps, CoreContainerState> {
  constructor(props: HeaderProps) {
    super(props);

    this.state = {
      componentMapping: this.props.componentMapping || ComponentMapping,
    };
  }

  render() {
    const { id, topHeaderChecker } = this.props;
    const isHeaderTop =
      topHeaderChecker === true

    return (
      <HeaderContainer id={id} className={isHeaderTop ? "header-top" : ""}>
        {this.childComponents &&
          this.childComponents.map((item, k) => {
            if (k < 6) {
              return (
                <div className={`component-${k}`} key={k}>
                  {item}
                </div>
              );
            }
            return null;
          })}
        {this.childComponents.length < 6 && this.placeholderComponent}
      </HeaderContainer>
    );
  }
}
